import type { HyloServices } from '@/model';
import { createHyloServices } from '@/core';
import { createElement, StrictMode } from 'react';
import { flushSync } from 'react-dom';
import type { Root } from 'react-dom/client';
import { App } from './App';

export function loadServices(): HyloServices {
  return createHyloServices({ fake: import.meta.env.VITE_HYLO_FAKE === '1' });
}

/** Install services-phase effects before Core's queued restore can replay accepted account removal.
 * Keep creation and the initial commit in one turn: an await/render gap can lose retirement callbacks.
 */
export function mountApplication(root: Pick<Root, 'render'>, createServices: () => HyloServices = loadServices): void {
  flushSync(() => root.render(createElement(StrictMode, null, createElement(App, { services: createServices() }))));
}
